import React, { useEffect, useState } from "react";
import { MapPin } from "lucide-react";

const program = [
  { time: "", title: "Anreise / Hotel Check-In", where: "" },
  { time: "15:30", title: "Get Together + Aperitivo & Willkommen", where: "Verdampferturm" },
  { time: "16:00", title: "Superspäti × MC Fitti & UKO Microshops „Creator Product Launch“", where: "Verdampferturm" },
  { time: "17:00", title: "Candy Peak TikTok-Live-Shopping-Session", where: "Superspäti im Verdampferturm" },
  { time: "18:00", title: "Festival „Urban Street Food“", where: "Verdampferturm" },
  { time: "19:00", title: "DarTom / Schlafi Livestream Twitch „Fionntime & Friends“", where: "Verdampferturm", parallel: { title: "Eröffnung Schmiede Werkschau", where: "Schmiede Haupteingang" } },
  { time: "21:15", title: "Superspäti × MC Fitti Show", where: "Superspäti im Verdampferturm" },
  { time: "22:00", suffix: "– 02:00", title: "CRTR Studios × Superspäti Aftershow Party mit DJ Phil Preuss & Friends", where: "Superspäti im Verdampferturm" },
  { time: "00:00", nextDay: true, title: "Live: DJ Phil Preuss & TULATU", where: "Superspäti im Verdampferturm" },
];

const EVENT_DAY = "2026-09-25";
const startOf = (t, nextDay) => new Date(`${nextDay ? "2026-09-26" : EVENT_DAY}T${t || "00:00"}:00+02:00`).getTime();
const EVENT_END = new Date(`2026-09-26T05:00:00+02:00`).getTime();

const currentIndex = (now) => {
  if (now < startOf("00:00") || now >= EVENT_END) return -1;
  let idx = 0;
  program.forEach((p, i) => { if (p.time && now >= startOf(p.time, p.nextDay)) idx = i; });
  return idx;
};

const Where = ({ children }) => (
  <span className="mt-1 inline-flex items-center gap-1 text-xs text-white/50">
    <MapPin className="h-3 w-3 text-[var(--crtr-yellow)]" /> {children}
  </span>
);

const readNow = () => {
  const q = new URLSearchParams(window.location.search).get("now");
  return q ? new Date(q).getTime() : Date.now();
};

export default function Timeline() {
  const [active, setActive] = useState(() => currentIndex(readNow()));

  useEffect(() => {
    const id = setInterval(() => setActive(currentIndex(readNow())), 30000);
    return () => clearInterval(id);
  }, []);

  return (
    <div data-testid="eventinfo-timeline" className="pt-4">
      <span className="mono-label block text-[11px] text-white/50">Programm · 25.09.2026</span>
      <ol className="relative mt-6 border-l border-white/15">
        {program.map((p, i) => {
          const isNow = i === active;
          const isPast = active > -1 && i < active;
          return (
            <li key={i} data-testid={`timeline-item-${i}`} data-state={isNow ? "now" : isPast ? "past" : "upcoming"}
              className={`relative pb-8 pl-8 transition-opacity duration-500 last:pb-0 ${isPast ? "opacity-40" : ""}`}>
              {isNow ? (
                <span className="absolute -left-[7px] top-1.5 flex h-[13px] w-[13px]">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[var(--crtr-yellow)] opacity-60" />
                  <span className="relative inline-flex h-[13px] w-[13px] rounded-full bg-[var(--crtr-yellow)]" />
                </span>
              ) : (
                <span className={`absolute -left-[5px] top-2 h-[9px] w-[9px] rounded-full ${p.time ? "bg-[var(--crtr-yellow)]" : "border border-white/40 bg-transparent"}`} />
              )}
              <div className={`grid gap-1 sm:grid-cols-[92px_1fr] sm:gap-6 ${isNow ? "-mx-4 rounded-2xl border border-[var(--crtr-yellow)]/40 bg-[var(--crtr-yellow)]/10 px-4 py-4" : ""}`}>
                <span className="font-display text-xl tabular-nums text-white sm:text-2xl">
                  {p.time || "—"}
                  {p.suffix && <span className="mono-label ml-1.5 text-[10px] text-[var(--crtr-yellow)] sm:ml-0 sm:block">{p.suffix}</span>}
                </span>
                <div>
                  {isNow && (
                    <span data-testid="timeline-now-badge" className="mono-label mb-2 inline-flex items-center gap-2 rounded-full bg-[var(--crtr-yellow)] px-2.5 py-1 text-[9px] text-black">
                      <span className="h-1.5 w-1.5 rounded-full bg-black" /> Jetzt
                    </span>
                  )}
                  <p className="font-medium text-white">{p.title}</p>
                  {p.where && <Where>{p.where}</Where>}
                  {p.parallel && (
                    <div className="mt-3 border-l-2 border-[var(--crtr-yellow)]/40 pl-3">
                      <span className="mono-label block text-[10px] text-[var(--crtr-yellow)]">Parallel</span>
                      <p className="mt-1 text-white/85">{p.parallel.title}</p>
                      <Where>{p.parallel.where}</Where>
                    </div>
                  )}
                </div>
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
